/**
 * Shared "chrome" copy (pt-PT): app frame, navigation, roles, module names,
 * status badges and small shared bits. Page-specific copy lives in the per-area
 * files next to this one. English mirrors this in `../en/chrome.ts`.
 */
export const common = {
  loading: 'A carregar…',
  search: 'Procurar',
  save: 'Guardar',
  cancel: 'Cancelar',
  edit: 'Editar',
  delete: 'Eliminar',
  remove: 'Remover',
  add: 'Adicionar',
  close: 'Fechar',
  back: 'Voltar',
  confirm: 'Confirmar',
  all: 'Todos',
  none: 'Nenhum',
  yes: 'Sim',
  no: 'Não',
  clear: 'Limpar',
  apply: 'Aplicar',
  noResults: 'Sem resultados.',
  error: 'Ocorreu um erro.',
};

export const roles = {
  admin: 'Administração',
  manager: 'Gestão',
  researcher: 'Investigador',
  direction: 'Direção',
  collaborator: 'Colaborador',
};

export const modules = {
  colaboradores: 'Colaboradores',
  onboarding: 'Onboarding',
  rh: 'RH',
  safelab: 'SafeLab',
  permissoes: 'Permissões',
  activeDirectory: 'Active Directory',
  definicoes: 'Definições',
  dashboard: 'Dashboard',
  viaturas: 'Viaturas',
  equipa: 'Equipas de Investigação',
  artigos: 'Produção Científica',
  presencas: 'Registo Presenças',
};

export const moduleHints = {
  colaboradores: 'Gestão da ficha dos colaboradores.',
  onboarding: 'Convites e revisão de novos colaboradores.',
  rh: 'Recursos Humanos.',
  safelab: 'Segurança e saúde no laboratório.',
  permissoes: 'Atribuição de acessos a módulos.',
  activeDirectory: 'Aprovisionamento de contas AD.',
  definicoes: 'Configuração do portal (campos, integrações).',
  dashboard: 'Visão geral do portal.',
  viaturas: 'Viaturas e lugares de estacionamento.',
  equipa: 'Equipas de Investigação e Linhas Temáticas (SISTRADE).',
  artigos: 'Produção científica (artigos) via Scopus/Elsevier.',
  presencas: 'Registos diários de assiduidade (API ou BD interna).',
};

export const shell = {
  brandSub: 'Gestão institucional',
};

export const topbar = {
  menu: 'Menu',
  searchTitle: 'Procurar (Ctrl+K)',
  lightMode: 'Modo claro',
  darkMode: 'Modo escuro',
  toggleTheme: 'Alternar tema',
  logout: 'Sair',
  language: 'Idioma',
  switchToEnglish: 'Switch to English',
  switchToPortuguese: 'Mudar para Português',
};

export const nav = {
  painel: 'Painel',
  meuPerfil: 'Meu Perfil',
  registos: 'Registos',
  convites: 'Convites',
  novoRegisto: 'Novo Registo',
  it: 'Administração de TI',
  sections: {
    essentials: 'Essenciais',
    pessoas: 'Pessoas',
    onboarding: 'Onboarding',
    investigacao: 'Investigação',
    laboratorio: 'Laboratório',
    sistema: 'Sistema',
  },
  settings: {
    global: 'Configuração Global',
    campos: 'Campos da ficha',
    painel: 'Painel',
    integracao: 'Integração SISTRADE',
  },
};

export const notifications = {
  title: 'Notificações',
  empty: 'Sem notificações. 🎉',
};

export const attendance = {
  title: 'Registo Presenças',
  subtitle: 'Assiduidade diária dos colaboradores',
  chip: {
    off: 'Por configurar',
    configured: 'Ligação configurada',
    linked: 'Ligado',
  },
  prepared: {
    title: 'Módulo preparado',
    body: 'A estrutura está pronta para ler os registos por API ou por base de dados interna. Falta apenas o identificador que liga cada colaborador aos registos diários — será configurado quando estiver disponível.',
  },
  records: {
    title: 'Registos',
    empty: 'Sem registos para mostrar.',
  },
  table: {
    date: 'Data',
    checkIn: 'Entrada',
    checkOut: 'Saída',
    status: 'Estado',
  },
};

export const impersonation = {
  bannerPrefix: 'A ver a aplicação como',
  bannerActor: 'sessão iniciada por {name}',
  stop: 'Terminar',
};

export const cmd = {
  aria: 'Procurar',
  placeholder: 'Procurar módulos, páginas…',
  empty: 'Nada encontrado.',
  hintNavigate: 'navegar',
  hintOpen: 'abrir',
  hintClose: 'fechar',
};

export const status = {
  pendingReview: 'Por rever',
  changesRequested: 'Correções pedidas',
  approved: 'Aprovado',
  launchedInSistrade: 'Lançado no SISTRADE',
  rejected: 'Rejeitado',
  source: {
    manager: 'Gestor',
    selfRegistration: 'Convite',
  },
  invite: {
    pending: 'Pendente',
    submitted: 'Submetido',
    cancelled: 'Cancelado',
    expired: 'Expirado',
  },
  delivery: {
    email: 'Email',
    link: 'Link',
    code: 'Código',
  },
};

export const tabbar = {
  collaborator: 'Colaborador',
  record: 'Registo',
};

export const shared = {
  noData: 'Sem dados.',
  noResults: 'Sem resultados.',
  active: 'Ativo',
  inactive: 'Inativo',
  /** Default heading for the custom Painel cards section (admin can override). */
  customCardsHeading: 'Produção Científica',
};

export const bilingual = {
  pt: 'Português',
  en: 'Inglês',
  translate: 'Traduzir',
  translating: 'A traduzir…',
  unconfigured: 'Tradução automática não configurada — preencha o inglês à mão.',
  failed: 'Não foi possível traduzir automaticamente.',
};
